export default __webpack_public_path__ + "static/pro@768_2x-81defcaa78c9a5954a079a073b4acb9f.webp";